import styled from 'styled-components';
import { DX } from '../../../../theme/v2';

/* Two views of one stage, so they sit together as one control rather than as two buttons that
   happen to be next to each other. The count travels with the label: it is the only place the
   reader learns what is on the other tab without going there. */
export const TabRow = styled.div`
  display: inline-flex;
  align-items: center;
  gap: 2px;
  padding: 2px;
  border-radius: ${DX.radius.control};
  background: ${DX.surfaceSunken};
`;

export const TabButton = styled.button.attrs({ type: 'button' })`
  display: inline-flex;
  align-items: center;
  gap: ${DX.space[2]};
  height: calc(${DX.control.base} - 4px);
  padding: 0 ${DX.space[3]};
  border: none;
  border-radius: calc(${DX.radius.control} - 1px);
  background: none;
  font-size: ${DX.fz.sm};
  font-weight: ${DX.fw.regular};
  line-height: ${DX.lh.sm};
  color: ${DX.textMuted};
  cursor: pointer;
  white-space: nowrap;
  transition:
    background-color ${DX.duration} ${DX.ease},
    color ${DX.duration} ${DX.ease};

  .n {
    font-variant-numeric: tabular-nums;
    color: ${DX.textFaint};
  }

  &:hover {
    color: ${DX.text};
  }

  &[data-active='true'] {
    background: ${DX.surface};
    font-weight: ${DX.fw.medium};
    color: ${DX.text};
  }

  &[data-active='true'] .n {
    color: ${DX.textMuted};
  }

  /* A number that is a problem is coloured on the tab you are not looking at, which is the only
     time it has anything to tell you. */
  &[data-tone='attention'] .n {
    color: ${DX.tone.attention};
  }

  &[data-tone='warning'] .n {
    color: ${DX.tone.warning};
  }
`;

/* The kind of a finding, said in the margin — an error, a mandatory fix, a warning — so the
   sentence beside it can be the finding itself and not its classification. */
export const WarningName = styled.button.attrs({ type: 'button' })`
  display: inline-flex;
  align-items: center;
  gap: ${DX.space[3]};
  max-width: 100%;
  padding: 2px ${DX.space[2]};
  margin-left: calc(-1 * ${DX.space[2]});
  border: none;
  border-radius: ${DX.radius.control};
  background: none;
  font-size: ${DX.fz.sm};
  line-height: ${DX.lh.sm};
  color: ${DX.text};
  text-align: left;
  cursor: pointer;

  .mark {
    flex-shrink: 0;
    width: 6px;
    height: 6px;
    border-radius: 50%;
    background: ${({ $tone }) => $tone || DX.tone.idle};
  }

  .label {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .n {
    color: ${DX.textMuted};
    font-variant-numeric: tabular-nums;
  }

  &:hover {
    background: ${DX.hover};
  }
`;

/* The refresh time is a footnote to the button beside it, so it is the size of a footnote. */
export const RefreshedAt = styled.span`
  font-size: ${DX.fz.xs};
  color: ${DX.textFaint};
  white-space: nowrap;
`;
